import React, { type PropsWithChildren, useContext, type JSX } from "react";
import { twMerge } from "tailwind-merge";

import SupChevronDown from "../../../../icons/ChevronDown";

import { Context } from "../context";

interface AccordionSummaryProps {
  expandIcon?: JSX.Element | null;
  className?: string;
  iconClassName?: string;
}

const COLORS = {
  primary: "[&.active]:bg-primary-200 text-neutral-900",
  success: "bg-success-50 text-success-800",
  error: "bg-error-50 text-error-800",
  info: "bg-info-25 text-info-800",
  warning: "bg-warning-50 text-warning-800",
} as const;

export function SupAccordionSummary({ className, iconClassName, children, expandIcon = <SupChevronDown width={20} height={20} /> }: PropsWithChildren<AccordionSummaryProps>) {
  const { variant, expanded, disabled, collapsible, toggle } = useContext(Context);

  return (
    <div
      className={twMerge(
        "sup-accordion-summary relative pr-5 transition-colors",
        variant && COLORS[variant],
        disabled ? "cursor-default" : "cursor-pointer",
        !collapsible && "cursor-default",
        expanded && "active",
        className
      )}
      onClick={toggle}
    >
      {children}
      {expandIcon && <span
        className={twMerge(
          "sup-accordion-summary-icon absolute right-0 top-1/2 -translate-y-1/2 transition-transform duration-200",
          iconClassName,
          expanded && "rotate-180",
          collapsible ? "opacity-100" : "opacity-44"
        )}
      >
        {expandIcon}
      </span>}
    </div>
  );
}
